import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';

function AcceptButton({ handler, label }: { handler: () => void, label: string }): JSX.Element {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="left"
      overlay={(
        <Tooltip id="accept-button-tooltip">
          {t('Accept_Action_Description')}
        </Tooltip>
      )}
    >
      <Button variant="link" className="linkactions" onClick={handler}>
        <FaCheck />
        {label && (<span>{label}</span>)}
      </Button>
    </OverlayTrigger>
  );
}

export default AcceptButton;
